export const NUM_TRACKS=9;
export const ADD_TRACKS=6;
export const LOAD_TIME = 200;


